<template>
  <component :is="componentType" v-model="isOpen" :side="side" v-bind="$attrs">
     <div class="flex items-center w-full"
        :class="[header ? (runtimeConfig?.public?.partnerCode?.toLowerCase() === 'oneindiamall' ? 'bg-gradient-to-b from-[#CA5096] to-[#ea71b5] pb-4' : 'bg-gradient-to-b from-yellow-50 to-gray-50 pb-4') : '', !backIcon ? 'justify-between' : 'bgColor-figma']" >
      <div v-if="backIcon" class="flex items-center justify-center size-7 bg-white rounded-full border-1.5 border-white cursor-pointer mr-2"
        @click="props.backIconClick ? props.backIconClick() : null">
        <UIcon :name="backIcon" class="size-5 text-primary-500" />
      </div>
      <div v-if="header" class="text-lg font-medium">{{ header }}</div>
     </div>
    <div v-if="closeIcon" class="flex w-full" :class="iconClass">
      <div class="flex items-center justify-center size-7 bg-white rounded-full border-1.5 border-white cursor-pointer"  @click="handleCloseIcon(); isOpen = false; emit('close')">
        <UIcon :name="iconName" class="size-5 text-primary-500" />
      </div>
    </div>
    <div ref="overlayContent" class="flex-none" :class="[containerClass,height]">
      <slot />
    </div>
  </component>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, watch } from "vue";
import { GoogleAnalytics } from "~/google_analytics/events";
import { EventParameter } from "~/google_analytics/events.enum";
import { ref } from "vue";
const overlayContent = ref<HTMLElement | null>(null);
const getModalTitle = () => {
  if (!overlayContent.value) return 'unknown';

  const selectors = [
    '[data-title]',
    'h1',
    'h2',
    'h3',
    '.text-lg',
    '.font-medium'
  ];
  console.log('Overlay content:', overlayContent.value);

  for (const selector of selectors) {
    const el = overlayContent.value.querySelector(selector);
    if (el?.textContent?.trim()) {
      return el.textContent.trim();
    }
  }

  return 'unknown';
};

const props = defineProps({
  type: { type: String, optional: true },
  side: { type: String, default: 'bottom' },
  closeIcon: { type: Boolean, default: true },
  containerClass: { type: String, default: '' },
  header:{type:String, default: null},
  backIcon: { type: String, default: null },
  backIconClick: { type: Function, default: null },
  height: { type: String, default: '' }
});

const emit = defineEmits(['close']);
const { isMobile, isDesktopOrTablet } = useDevice();
const isOpen = defineModel();
const runtimeConfig = useRuntimeConfig();

const isRight = computed(() => isDesktopOrTablet && props.side === 'right');
const componentType = computed(() => {
  if (props.type) return `U${props.type.charAt(0).toUpperCase() + props.type.slice(1)}`;
  return (isRight.value || isMobile ? 'USlideover' : 'UModal');
});
const iconName = computed(() => (isRight.value ? 'i-lucide-circle-x' : 'i-lucide-x'));
const iconClass = computed(() => (isRight.value ? 'justify-end px-5 pt-5' : 'justify-center absolute -top-10'));

watch(isOpen, (open) => {
  if (open) {
    requestAnimationFrame(() => {
      const active = document.activeElement as HTMLElement | null;
      if (active) active.blur();
    });

    history.pushState({ overlay: true }, "");
  }
});

const handleCloseIcon = () => {
  const modalName = props.header || getModalTitle();
  console.log('Tracked Modal:', modalName);
  GoogleAnalytics.popupClose({
    [EventParameter.CTA_NAME]: 'close_icon',
    [EventParameter.CTA_LABEL]: modalName
  });
}

const handleBack = () => {
  if (isOpen.value) {
    isOpen.value = false;
  }
};

let listenerFn: any;

onMounted(() => {
  listenerFn = () => handleBack();
  window.addEventListener("popstate", listenerFn);
});

onUnmounted(() => {
  window.removeEventListener("popstate", listenerFn);
});
</script>